module.exports = __webpack_public_path__ + "img/bg-accident-item-8.2b434d3c.png";